module.exports = __webpack_public_path__ + "img/lectures.a622fa88.svg";